import React, { ReactNode } from 'react';
import { Collapse, CollapseProps } from 'antd';
import styled from 'styled-components';

const { Panel } = Collapse;

export const StyledCollapse = styled(Collapse)<{ $disabled?: boolean }>`
  margin: 24px 0;
  background: #fff;
  border: 1px solid #e8e8e8;

  ${({ $disabled }) => $disabled && 'opacity: 0.6;'}

  & > .ant-collapse-item {
    border: 0;

    .ant-collapse-header {
      padding: 13px 24px;
    }
  }

  .ant-collapse-content {
    border-top: 1px solid #e8e8e8;
  }

  .ant-collapse-extra {
    padding-inline-start: 12px;
  }
`;

export const CardTitle = styled.span`
  display: flex;
  gap: 8px;
  align-items: center;
  color: #3d3d3d;
  font-weight: 600;
  font-size: 16px;
`;

const CardSubtitle = styled.p`
  margin-bottom: 0;
  color: #707070;
  font-size: 12px;
  font-weight: 400;
`;

type Props = {
  customKey?: string | number;
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  defaultOpen?: boolean;
  extra?: ReactNode;
  collapseProps?: CollapseProps;
  className?: string;
  disabled?: boolean;
};

export const CardCollapse = ({
  customKey = 0,
  title,
  subtitle,
  children,
  defaultOpen,
  extra,
  collapseProps,
  className,
  disabled,
}: Props) => {
  return (
    <StyledCollapse
      defaultActiveKey={defaultOpen ? [customKey] : []}
      expandIconPosition="end"
      className={className}
      $disabled={disabled}
      {...collapseProps}
    >
      <Panel
        key={customKey}
        header={
          <>
            <CardTitle>{title}</CardTitle>
            {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
          </>
        }
        extra={extra}
        {...(disabled ? { collapsible: 'disabled' } : {})}
      >
        {children}
      </Panel>
    </StyledCollapse>
  );
};
